import React, { FunctionComponent, ReactNode, KeyboardEvent, MouseEvent, useRef } from 'react';
import useSwaggerOverrideStyles from './CustomSwaggerStylesContainer.styles';

interface CustomSwaggerStylesContainerProps {
  children: ReactNode;
  onClick?: (event: MouseEvent<HTMLDivElement> | KeyboardEvent<HTMLDivElement>) => void;
}

const CustomSwaggerStylesContainer: FunctionComponent<CustomSwaggerStylesContainerProps> = ({
  children,
  onClick,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const {
    classes: { container },
    cx,
  } = useSwaggerOverrideStyles();

  // extend onClick to trigger on accessibile keyboard interactions
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      onClick(event);
    }
  };

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  const containerProps = onClick
    ? {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: 'button',
        tabIndex: 0,
      }
    : {};

  return (
    <div ref={ref} className={cx(container, 'swagger-ui')} {...containerProps}>
      <div className='swagger-ui-overrides'>{children}</div>
    </div>
  );
};

export default CustomSwaggerStylesContainer;
